// extracted by mini-css-extract-plugin
export default {"header":"header_header__T3f6i"};